import { getTestIds } from 'seagull/utils/TestIds';
import { StepsContainerDesktop } from "./StepsContainerDesktop";
import { StepsContainerMobile } from "./StepsContainerMobile";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetStepsContainerTID = parentTestId => getTestIds({
  parentTestId
});
export const StepsContainer = _ref => {
  let {
    testId,
    currentStep,
    direction,
    onBack,
    onNext,
    relationship,
    isMobile
  } = _ref;
  if (isMobile) {
    return /*#__PURE__*/_jsx(StepsContainerMobile, {
      testId: testId,
      currentStep: currentStep,
      direction: direction,
      onNext: onNext,
      relationship: relationship
    });
  }
  return /*#__PURE__*/_jsx(StepsContainerDesktop, {
    testId: testId,
    currentStep: currentStep,
    direction: direction,
    onBack: onBack,
    onNext: onNext,
    relationship: relationship
  });
};